import { render, staticRenderFns } from "./ClassifyDispatchAssets.vue?vue&type=template&id=3a1950d4&scoped=true"
import script from "./ClassifyDispatchAssets.vue?vue&type=script&lang=js"
export * from "./ClassifyDispatchAssets.vue?vue&type=script&lang=js"
import style0 from "./ClassifyDispatchAssets.vue?vue&type=style&index=0&id=3a1950d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1950d4",
  null
  
)

export default component.exports